module.exports = __webpack_public_path__ + "static/media/44650397_2199884670086712_6503369239708041216_o.6610e22a.jpg";